/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.pricing.controllers', [])

.controller('PricingController', ['$scope', function($scope) {

    $scope.pricing = {

      componentType: 'priceList',
      priceListModel: [],
      selectedPriceListId: '',

      init: function() {
        $scope.$emit('Application::contentTitleChange', { title: 'Pricing' });

        $scope.$on('PricingAdmissionController::admissionListUpdate', this.onAdmissionListUpdate);
        $scope.$on('PricingListsController::priceListsUpdate', this.onPriceListsUpdate);
        $scope.$on('PricingSidebarController::selectList', this.onSelectList);
        $scope.$on('PricingListsController::priceListUpdate', this.onPriceListUpdate);
      },

      getCurrentPriceListName: function() {
        var self = $scope.pricing, i, ii, r = '';
        for (i=0, ii=self.priceListModel.length; i < ii; i++) {
          if (self.priceListModel[i].id === self.selectedPriceListId) {
            r = self.priceListModel[i].name;
            break;
          }
        }

        return r;
      },

      onPriceListsUpdate: function(e, data) {
        console.log('PricingController::onPriceListsUpdate');
        $scope.$parent.$broadcast('PricingController::priceListsUpdate', data);
        $scope.pricing.priceListModel = data.model;
        $scope.pricing.selectedPriceListId = data.selectedPriceListId;
      },

      onPriceListUpdate: function(e, data) {
        console.log('PricingController::onPriceListUpdate');
        $scope.$parent.$broadcast('PricingController::priceListsUpdate', data);
      },

      onAdmissionListUpdate: function(e, data) {
        console.log('PricingController::onAdmissionListUpdate');
        $scope.$parent.$broadcast('PricingController::admissionListUpdate', data);
      },

      onSelectList: function(e, data) {
        console.log('PricingController::onSelectList');
        $scope.$parent.$broadcast('PricingController::selectList', data);
        $scope.pricing.selectedPriceListId = data.id;
      }

    };

    $scope.pricing.init();

}]);